import {
	TypeColumn,
	TBreakpoint,
	TypeColAttrs,
	TypeColAttrValue
} from './Subcomponents/GridColumn/IGridColumn';

/**
 * Returns the parsed column classes
 * @param {TBreakpoint} breakpoint - the breakpoint
 * @param {TypeColAttrValue} breakpointValue - the breakpoint value
 * @param {TypeColAttrs} type - the type column attributes
 * @returns {string} - the parsed column classes
 */
function getParsedColClasses(breakpoint: TBreakpoint, breakpointValue: TypeColAttrValue, type: TypeColAttrs) {
	// Don't parse order and hide classes, they are handled separately
	if (type === 'order') {
		return;
	}

	if (type === 'hide') {
		return `d-${breakpoint}-none`;
	} else {
		if (breakpoint === 'xs') {
			return `${type}-${breakpointValue}`;
		}

		return `${type}-${breakpoint}-${breakpointValue}`;
	}
}

/**
 * Returns the parsed column classes for breakpoints
 * @param {any} breakpoints - breakpoints mapping
 * @returns {Array<string>} parsed column classes
 */
export function parseColClasses(breakpoints: {
	[key in TBreakpoint]: TypeColumn | undefined;
}) {
	const result: string[] = [];
	const breakpointsArr = Object.keys(breakpoints || {}) as Array<keyof typeof breakpoints>;

	breakpointsArr.forEach((breakpoint) => {
		const breakpointValue = breakpoints[breakpoint];

		// If prop not passed
		if (undefined === breakpointValue) {
			return;
		}

		const isSpan = typeof breakpointValue === 'number';
		const isAttrs = typeof breakpointValue === 'object';
		let colClasses = 'col-12';

		// Columns passed, just a number
		if (isSpan) {
			colClasses = getParsedColClasses(breakpoint, breakpointValue, 'col');
		} else if (isAttrs) {
			// Object passed
			colClasses = '';

			const attrs = Object.keys(breakpointValue || {}) as Array<keyof typeof breakpointValue>;

			attrs.forEach((attr) => {
				const value = breakpointValue[attr] as TypeColAttrValue;
				const type = attr as TypeColAttrs;
				const parsedColumnClasses = getParsedColClasses(breakpoint, value, type);

				if (parsedColumnClasses) {
					colClasses += ` ${parsedColumnClasses}`;
				}
			});
		}

		result.push(colClasses.trim());
	});

	// Add default col-12 class if no classes provided
	if (!result.length) {
		result.push('col-12');
	}

	return result;
}
